import { render, staticRenderFns } from "./BulkAttachments.vue?vue&type=template&id=564c9e9c&scoped=true"
import script from "./BulkAttachments.vue?vue&type=script&lang=js"
export * from "./BulkAttachments.vue?vue&type=script&lang=js"
import style0 from "./BulkAttachments.vue?vue&type=style&index=0&id=564c9e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564c9e9c",
  null
  
)

export default component.exports